import { setLocaleObjectNamespace } from "../../../common/src/setLocaleObjectNamespace";

export default setLocaleObjectNamespace("pages", {
    registration: "Вход/регистрация",
    lobby: "Лобби",
    halls: "Залы",
    broadcast: "Трансляция",
    quiz: "Квиз",
    program: "Программа",
    members: "Участники",
    shop: "Магазин призов",
    profile: "Профиль участника",

    actions: "Действия",
    addPage: "Добавить страницу",
    openByDefault: "Открывать по умолчанию",
    openByDefaultTooltip: "Какая страница будет открываться при загрузке платформы первой для пользователей из каждого формата участия?",
    openForMembers: "Открывать для участников",
    openForMembersTooltip: "Какому формату участников будет доступна эта страница для просмотра?",
    pageName: "Название страницы",
    needDifferentPlayerVersion: "Для настройки страницы необходима другая версия плеера",
});
